import * as $runtime from "../runtime.js";
import * as Affjax from "../Affjax/index.js";
import * as Affjax$dRequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax$dRequestHeader from "../Affjax.RequestHeader/index.js";
import * as Affjax$dResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax$dWeb from "../Affjax.Web/index.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dBifunctor from "../Data.Bifunctor/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dHTTP$dMethod from "../Data.HTTP.Method/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dIndex from "../Foreign.Index/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dJSON from "../Foreign.JSON/index.js";
import * as Network$dRPCError from "../Network.RPCError/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $RemoteError = (tag, _1) => ({tag, _1});
const $Response = (tag, _1) => ({tag, _1});
const DecodingErrorIsSymbol = {reflectSymbol: () => "DecodingError"};
const methodIsSymbol = {reflectSymbol: () => "method"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const idIsSymbol = {reflectSymbol: () => "id"};
const bind = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const ix = /* #__PURE__ */ (() => Foreign$dIndex.indexString(Data$dIdentity.monadIdentity).index)();
const readString = /* #__PURE__ */ Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String");
const readNullOrUndefined = /* #__PURE__ */ Foreign.readNullOrUndefined(Data$dIdentity.monadIdentity);
const applicativeExceptT = /* #__PURE__ */ Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableMaybe.traverse(applicativeExceptT))();
const pure1 = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Effect$dAff.monadAff).pure)();
const throwError = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.monadThrowExceptT(Effect$dAff.monadAff).throwError)();
const toUnfoldable = /* #__PURE__ */ Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
const Success = value0 => $Response("Success", value0);
const RPCFailure = value0 => $Response("RPCFailure", value0);
const Request = x => x;
const UnexpectedStatus = value0 => $RemoteError("UnexpectedStatus", value0);
const NetworkError = value0 => $RemoteError("NetworkError", value0);
const DecodingError = value0 => $RemoteError("DecodingError", value0);
const RPCError = value0 => $RemoteError("RPCError", value0);
const aPIUrlSites = {apiUrl: v => "/api/v1/sites/rpc"};
const aPIUrlROS = {apiUrl: v => "/api/v1/ros/rpc"};
const aPIUrlPortal = {apiUrl: v => "/api/v1/portal/rpc"};
const aPIUrlPR = {apiUrl: v => "/api/v1/pr/rpc"};
const aPIUrlInternal = {apiUrl: v => "/api/v1/internal/rpc"};
const aPIUrlHQ = {apiUrl: v => "/api/v1/hq/rpc"};
const rpcMethodName = dict => dict.rpcMethodName;
const rpc$p = dictRPCMethodName => dictMonad => {
  const bind1 = dictMonad.Bind1().bind;
  const pure2 = dictMonad.Applicative0().pure;
  return run => req => bind1(run({id: "1", method: dictRPCMethodName.rpcMethodName(Type$dProxy.Proxy), params: req}))(res => pure2((() => {
    if (res.tag === "Right") {
      if (res._1.tag === "Success") { return Data$dEither.$Either("Right", res._1._1.result); }
      if (res._1.tag === "RPCFailure") { return Data$dEither.$Either("Left", $RemoteError("RPCError", res._1._1.error)); }
      $runtime.fail();
    }
    if (res.tag === "Left") { return Data$dEither.$Either("Left", res._1); }
    $runtime.fail();
  })()));
};
const remoteErrorToString = v => {
  if (v.tag === "UnexpectedStatus") { return "UnexpectedStatus: (StatusCode " + Data$dShow.showIntImpl(v._1) + ")"; }
  if (v.tag === "NetworkError") { return "NetworkError: " + v._1; }
  if (v.tag === "DecodingError") { return "DecodingError: " + v._1; }
  if (v.tag === "RPCError") { return "RPCError: " + Network$dRPCError.showRpcError.show(v._1); }
  $runtime.fail();
};
const rpc = dictRPCMethodName => dictMonad => {
  const map2 = dictMonad.Bind1().Apply0().Functor0().map;
  const rpc$p2 = rpc$p(dictRPCMethodName)(dictMonad);
  return run => {
    const $0 = map2(Data$dBifunctor.bifunctorEither.bimap(remoteErrorToString)(Data$dBifunctor.identity));
    const $1 = rpc$p2(run);
    return x => $0($1(x));
  };
};
const newtypeRequest = {Coercible0: () => {}};
const genericResponse = {
  to: x => {
    if (x.tag === "Inl") { return $Response("Success", x._1); }
    if (x.tag === "Inr") { return $Response("RPCFailure", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Success") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "RPCFailure") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const genericRequest = {to: x => x, from: x => x};
const genericRemoteError = {
  to: x => {
    if (x.tag === "Inl") { return $RemoteError("UnexpectedStatus", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $RemoteError("NetworkError", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $RemoteError("DecodingError", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return $RemoteError("RPCError", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "UnexpectedStatus") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "NetworkError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "DecodingError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "RPCError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const showRemoteError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["(StatusCode " + Data$dShow.showIntImpl(v) + ")"]})({reflectSymbol: () => "UnexpectedStatus"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({reflectSymbol: () => "NetworkError"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})(DecodingErrorIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Network$dRPCError.showRpcError.show(v)]})({reflectSymbol: () => "RPCError"});
    return x => {
      const $4 = genericRemoteError.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const errorUnexpectedStatus = UnexpectedStatus;
const eqRemoteError = {
  eq: x => y => {
    if (x.tag === "UnexpectedStatus") {
      if (y.tag === "UnexpectedStatus") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "NetworkError") {
      if (y.tag === "NetworkError") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "DecodingError") {
      if (y.tag === "DecodingError") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "RPCError") {
      if (y.tag === "RPCError") {
        if (x._1.tag === "MethodNotFound") {
          if (y._1.tag === "MethodNotFound") { return x._1._1 === y._1._1; }
          return false;
        }
        if (x._1.tag === "InvalidParams") {
          if (y._1.tag === "InvalidParams") { return x._1._1 === y._1._1; }
          return false;
        }
        if (x._1.tag === "OtherError") {
          if (y._1.tag === "OtherError") { return x._1._1 === y._1._1 && x._1._2 === y._1._2; }
          return false;
        }
        return false;
      }
      return false;
    }
    return false;
  }
};
const encodeRequest = dictEncode => dictEncodeWithOptions => (
  {
    encode: Foreign$dEncoding.defaultEncode(genericRequest)(Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Request"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "params"
      })(dictEncodeWithOptions))(methodIsSymbol)(encodeWithOptionsOther))(idIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()))
  }
);
const decodeResponse = dictDecode => {
  const decode1 = dictDecode.decode;
  return {
    decode: value => bind(bind(ix(value)("id"))(readString))(id => bind(bind(bind(ix(value)("error"))(readNullOrUndefined))(traverse(Network$dRPCError.decodeRPCError.decode)))(mError => {
      if (mError.tag === "Just") { return applicativeExceptT.pure($Response("RPCFailure", {id, error: mError._1})); }
      if (mError.tag === "Nothing") { return bind(bind(ix(value)("result"))(decode1))(result => applicativeExceptT.pure($Response("Success", {id, result}))); }
      $runtime.fail();
    }))
  };
};
const decodeJSONE = dictDecode => {
  const decodeJSON = Foreign$dJSON.decodeJSONWith(dictDecode.decode);
  return json => {
    const v = decodeJSON(json);
    if (v.tag === "Right") { return pure1(v._1); }
    if (v.tag === "Left") {
      return throwError({
        type: "DecodingError",
        value: Data$dString$dCommon.joinWith("\n")(Data$dFunctor.arrayMap(Foreign.showForeignError.show)(toUnfoldable(Data$dList$dTypes.$List("Cons", v._1._1, v._1._2))))
      });
    }
    $runtime.fail();
  };
};
const decodeJSON$p = dictDecode => {
  const decodeJSON = Foreign$dJSON.decodeJSONWith(dictDecode.decode);
  return json => {
    const v = decodeJSON(json);
    if (v.tag === "Right") { return Data$dEither.$Either("Right", v._1); }
    if (v.tag === "Left") {
      return Data$dEither.$Either(
        "Left",
        $RemoteError(
          "DecodingError",
          Data$dString$dCommon.joinWith("\n")(Data$dFunctor.arrayMap(Foreign.showForeignError.show)(toUnfoldable(Data$dList$dTypes.$List("Cons", v._1._1, v._1._2))))
        )
      );
    }
    $runtime.fail();
  };
};
const runAffjax = dictEncode => dictDecode => {
  const decodeJSON$p1 = decodeJSON$p(dictDecode);
  return dictRPCMethodName => api => authHeaders => request => Effect$dAff._map(v => {
    if (v.tag === "Left") { return Data$dEither.$Either("Left", $RemoteError("NetworkError", Affjax.printError(v._1))); }
    if (v.tag === "Right") {
      if (v._1.status === 200) { return decodeJSON$p1(v._1.body); }
      return Data$dEither.$Either("Left", $RemoteError("UnexpectedStatus", v._1.status));
    }
    $runtime.fail();
  })(Affjax.request(Affjax$dWeb.driver)({
    ...Affjax.defaultRequest,
    url: api + "?" + dictRPCMethodName.rpcMethodName(Type$dProxy.Proxy),
    headers: Data$dSemigroup.concatArray(authHeaders)([Affjax$dRequestHeader.$RequestHeader("ContentType", "application/json")]),
    method: Data$dEither.$Either("Left", Data$dHTTP$dMethod.POST),
    content: Data$dMaybe.$Maybe("Just", Affjax$dRequestBody.$RequestBody("String", Foreign$dInternal$dStringify.unsafeStringify(dictEncode.encode(request)))),
    responseFormat: Affjax$dResponseFormat.$ResponseFormat("String", Affjax$dResponseFormat.identity)
  }));
};
const apiUrl = dict => dict.apiUrl;
export {
  $RemoteError,
  $Response,
  DecodingError,
  DecodingErrorIsSymbol,
  NetworkError,
  RPCError,
  RPCFailure,
  Request,
  Success,
  UnexpectedStatus,
  aPIUrlHQ,
  aPIUrlInternal,
  aPIUrlPR,
  aPIUrlPortal,
  aPIUrlROS,
  aPIUrlSites,
  apiUrl,
  applicativeExceptT,
  bind,
  decodeJSON$p,
  decodeJSONE,
  decodeResponse,
  encodeRequest,
  encodeWithOptionsOther,
  eqRemoteError,
  errorUnexpectedStatus,
  genericRemoteError,
  genericRequest,
  genericResponse,
  idIsSymbol,
  ix,
  methodIsSymbol,
  newtypeRequest,
  pure1,
  readNullOrUndefined,
  readString,
  remoteErrorToString,
  rpc,
  rpc$p,
  rpcMethodName,
  runAffjax,
  showRemoteError,
  throwError,
  toUnfoldable,
  traverse
};
